import React from 'react';
import { motion, useViewportScroll, useTransform } from 'framer-motion';
import feature from '../assets/HaulRadarTripleiPhone.png';

const MobileShowcase = () => {
  const { scrollYProgress } = useViewportScroll();

  // Map scroll position to translateY for parallax effect with quicker rendering
  const translateY1 = useTransform(scrollYProgress, [0, 0.1], [50, 0]);
  const opacity1 = useTransform(scrollYProgress, [0, 0.1], [0, 1]);

  const translateY2 = useTransform(scrollYProgress, [0.1, 0.2], [50, 0]);
  const opacity2 = useTransform(scrollYProgress, [0.1, 0.2], [0, 1]);

  const translateY3 = useTransform(scrollYProgress, [0.2, 0.3], [50, 0]);
  const opacity3 = useTransform(scrollYProgress, [0.2, 0.3], [0, 1]);

  // Button appears much later
  const translateYButton = useTransform(scrollYProgress, [0.4, 0.5], [50, 0]);
  const opacityButton = useTransform(scrollYProgress, [0.4, 0.5], [0, 1]);

  return (
    <section className="bg-gray-100 py-20">
      <div className="container mx-auto px-6">
        <div className="text-center">
          <motion.h2
            className="text-4xl font-bold text-gray-800"
            style={{ translateY: translateY1, opacity: opacity1 }}
          >
            Why Choose HaulRadar?
          </motion.h2>
          <motion.p
            className="text-gray-600 mt-4"
            style={{ translateY: translateY2, opacity: opacity2 }}
          >
            Revolutionize construction trucking with our cutting-edge platform.
          </motion.p>
        </div>

        <div className="mt-16 flex flex-wrap justify-center">
          <div className="text-center">
                        <img
                          src={feature}
                          alt="Feature"
                          className="mx-auto mb-4"
                          style={{ width: '90%', height: 'auto' }} // Reduce image size by 10%
                        />
                        <h3 className="text-2xl font-semibold text-gray-800">Real-Time Productivity</h3>
                        <p className="text-gray-600 mt-4">
                          Plan, get estimates and monitor productivity of all the trucks on the job.
                        </p>
                      </div>
        </div>

        <motion.div
          className="text-center mt-16"
          style={{ translateY: translateYButton, opacity: opacityButton }}
        >
          <a
            href="https://dashboard.haulradar.com/sign-up"
            className="bg-black text-white font-bold py-3 px-6 rounded-full hover:bg-gray-800"
          >
            Get Started Today
          </a>
        </motion.div>
      </div>
    </section>
  );
};

export default MobileShowcase;
